module.exports = __webpack_public_path__ + "media/whale sharks/wall_sharks-1de50646.jpg";